import React from 'react'
import EditQuestionForm from './EditQuestionForm'



class FormQuestionSlide extends React.Component{

	getTemplateDefinition(slideTemplate,image,body){
		const hasImage=image===''? false:true
		let templateDefinition='BodyLeft'
		if(slideTemplate==='standard'){
			if(hasImage){
				templateDefinition='BodyLeftImageRight'
			} else templateDefinition='BodyLeft'
		}
		else if(slideTemplate==='right'){
			templateDefinition='BodyRightImageLeft'
		}
		else if(slideTemplate==='center'){
			if(hasImage){
				templateDefinition='BodyCenterImageCenter'
			}else{
				templateDefinition='BodyCenter'
			}
		}
		return templateDefinition
	}


	render(){
		
		const {question,transformScale,tempImage}=this.props

		let style={
			width: `calc(1280px * ${transformScale})`,
			height: `calc(800px * ${transformScale})`,
		}
		

		const slideTemplate=question.template || 'standard'
		const image=tempImage || question.image
		const template=this.getTemplateDefinition(slideTemplate,image,question.body)


	
		return(
			<div className="slideContainer slideContainer--form" style={style}>
				<EditQuestionForm	
					{...this.props}
					template={template}
					choices={question.choices}
				/>
			</div>
		)
	}
}



export default FormQuestionSlide
